import ComponentProps from "@/baseComponents/types/ComponentProps";
import { ChipVariants } from "@/types/consts";
import { Box, chakra, Tag, TagLabel, useMultiStyleConfig} from "@chakra-ui/react";

export interface ChipProps extends ComponentProps {
    text: string;
    variant: typeof ChipVariants[keyof typeof ChipVariants];
    ellipse?: boolean;
    ellipseColor?: string;
    isDimmed?: boolean;
}

export default chakra(Chip);
function Chip({ text, variant, ellipse, ellipseColor, isDimmed = false, theme = "brand", ...props }: ChipProps) {
  const styles = useMultiStyleConfig('Chip', {
    variant: variant,
    colorScheme: theme,
    ellipse,
    isDimmed
  })
      
  return (
    <Tag sx={{...styles.tag}} {...props}>
      {ellipse && (
        <Box
          width="0.75rem"
          height="0.75rem"
          m="0.375rem"
          mr="0.625rem"
          borderRadius="full"
          backgroundColor={ellipseColor ?? 'green.500'}
          flexShrink={0}
        />
      )}
      <TagLabel>{text}</TagLabel>
    </Tag>
  );
}
